import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var shareIcon = /*#__PURE__*/React.createElement("svg", {
  height: "16",
  width: "12",
  viewBox: "0 0 12 16",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.58 6.545h2.5c.324 0 .59.27.59.598a.595.595 0 0 1-.59.597h-1.9v7.066h9.64V7.74H8.725a.595.595 0 0 1-.59-.597c0-.329.265-.598.59-.598h2.695c.324 0 .58.299.58.627v8.28c0 .33-.256.548-.58.548H.58c-.324 0-.58-.219-.58-.547v-8.28c0-.329.256-.628.58-.628Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.23 10.91a.608.608 0 0 1-.593-.62V1.898l-2.53 2.354a.582.582 0 0 1-.839-.052.64.64 0 0 1 .05-.877L5.725.153a.577.577 0 0 1 .761-.02.608.608 0 0 1 .257.248l2.954 2.962a.64.64 0 0 1 .02.878.576.576 0 0 1-.84.02L6.823 2.177v8.113c0 .34-.267.62-.593.62Z"
})));

export { shareIcon as default };
//# sourceMappingURL=shareIcon.js.map
